import { makeStyles } from '@material-ui/core/styles';

export const useBulkEmailDrawerSequencesPreviewStyles = makeStyles(() => ({
  divider: {
    height: 2
  }
}));
